import { useCallback, useState } from 'react';

import { BoundedDateExample, CrossMonthRangeExample, CustomWeekStartExample, DateRangeSelectionExample, SingleDateExample } from 'components/experiment/ui/CustomDatePicker.example';
import CalendarInput from 'components/generic/CalendarInput.component';
import CalendarRangedInput from 'components/generic/CalendarRangedInput.component';
import logger from 'utils/logger.util';

const L = logger('DatePanel'); // eslint-disable-line no-unused-vars

const STYLE_PANEL_GRID = Object.freeze({
  display: 'grid',
  gridTemplateColumns: '.5fr 1fr',
  gap: '2em',
  padding: '3em',
  gridAutoRows: 'minmax(100px, auto) ',
});

const STYLE_CODE = Object.freeze({
  fontFace: 'monospaced',
  background: '#EcEcEc',
  whiteSpace: 'nowrap',
});

const STYLE_SECTION = Object.freeze({
  gridColumn: '1 / -1',
  borderTop: '2px solid #ddd',
  paddingTop: '2em',
  marginTop: '2em',
});

const STYLE_EXAMPLE = Object.freeze({
  border: '1px solid #e0e0e0',
  borderRadius: '8px',
  padding: '1.5em',
  background: '#fafafa',
});

const DatePanel = () => {
  const [bgn, setBgn] = useState();
  const [end, setEnd] = useState();

  const handleChange = useCallback((ev) => {
    L.debug('handleChange()', 'CalendarRangedInput ev:', ev);
    if (CalendarRangedInput.MODE.bgn === ev?.mode && 'select' === ev?.type) setBgn(ev?.iso);
    if (CalendarRangedInput.MODE.end === ev?.mode && 'select' === ev?.type) setEnd(ev?.iso);
  }, []);

  return (
    <div data-bem="DatePanel" style={STYLE_PANEL_GRID}>
      <p>
        <code style={STYLE_CODE}>{'<CalendarRangedInput >'}</code>&nbsp;:
      </p>

      <CalendarRangedInput bgn={bgn} end={end} onChange={handleChange} allowSameDay />

      <p>
        <code style={STYLE_CODE}>{'<CalendarInput>'}</code>&nbsp;:
      </p>
      <CalendarInput></CalendarInput>

      {/* CustomDatePicker Examples Section */}
      <div style={STYLE_SECTION}>
        <h2>CustomDatePicker Examples</h2>
      </div>

      <p>
        <code style={STYLE_CODE}>{'<CustomDatePicker>'}</code>&nbsp;Single Date:
      </p>
      <div style={STYLE_EXAMPLE}>
        <SingleDateExample />
      </div>

      <p>
        <code style={STYLE_CODE}>{'<CustomDatePicker>'}</code>&nbsp;Date Range:
      </p>
      <div style={STYLE_EXAMPLE}>
        <DateRangeSelectionExample />
      </div>

      <p>
        <code style={STYLE_CODE}>{'<CustomDatePicker>'}</code>&nbsp;Cross-Month Range (Leap Year):
      </p>
      <div style={STYLE_EXAMPLE}>
        <CrossMonthRangeExample />
      </div>

      <p>
        <code style={STYLE_CODE}>{'<CustomDatePicker>'}</code>&nbsp;Bounded Date:
      </p>
      <div style={STYLE_EXAMPLE}>
        <BoundedDateExample />
      </div>

      <p>
        <code style={STYLE_CODE}>{'<CustomDatePicker>'}</code>&nbsp;Custom Week Start:
      </p>
      <div style={STYLE_EXAMPLE}>
        <CustomWeekStartExample />
      </div>
    </div>
  );
};

export default DatePanel;
